// extracted by mini-css-extract-plugin
export default {"paymentProviderContent":"PaymentProvidersEditModal_paymentProviderContent__4XCYi","mainTabContent":"PaymentProvidersEditModal_mainTabContent__XGl6d"};